import { IconGift } from "@tabler/icons-react";
import { createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const BonusPage = lazy(() => import("./BonusPage").then((m) => ({ default: m.BonusPage })));
const page = (surface: "admin" | "portal") =>
  createElement(Suspense, { fallback: null }, createElement(BonusPage, { surface }));

export const routes: FeatureRoute[] = [
  { path: "/admin/bonus", roles: CAPS.admin.bonusRead, element: page("admin") },
  { path: "/portal/bonus", roles: CAPS.portal.bonusRead, element: page("portal") },
];

export const nav: NavItem[] = [
  { label: "Free rounds", path: "/admin/bonus", icon: IconGift, surface: "admin", roles: CAPS.admin.bonusRead },
  { label: "Free rounds", path: "/portal/bonus", icon: IconGift, surface: "portal", roles: CAPS.portal.bonusRead },
];
